import SpriteSymbol from "../../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "calendar",
  "use": "calendar-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" id=\"calendar\">\n  <path d=\"M17,13 L12,13 L12,18 L17,18 L17,13 Z M16,2 L16,4 L8,4 L8,2 L6,2 L6,4 L3.01,4 L3,22 L21,22 L21,4 L18,4 L18,2 L16,2 Z M19,20 L5,20 L5,9 L19,9 L19,20 Z\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol